<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/degrees`">
        <span>
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
        </span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h3>Редактирование академической степени</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="id" class="form-label col-md-3">
            ID
          </label>
          <div class="col-md-9">
            <input class="form-control" id="id" type="number"
                   min="0" step="1"
                   v-model="degree.id">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="name" class="form-label col-md-3">
            Наименование
          </label>
          <div class="col-md-9">
            <input class="form-control" id="name" type="text" v-model="degree.nameRu">
          </div>
        </div>
      </div>
    </div>

    <br/>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="maxCredits" class="form-label col-md-3">
            Максимум кредитов
          </label>
          <div class="col-md-9">
            <input class="form-control" id="maxCredits" type="number" min="0" step="1" v-model="degree.maxCredits">
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="page-footer justify-content-end"  v-if="isAdmin()">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import degreeService from "@/services/degreeService";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  computed: {
    degreeId() {
      return +this.$route.params.id;
    }
  },
  data() {
    return {
      isLoading: false,
      degree: {
        id: null,
        nameRu: null,
        maxCredits: null,
      }
    };
  },
  methods: {
    init() {
      if (this.degreeId === 0) {
        this.degree = {
          id: null,
          nameRu: null,
          maxCredits: null
        };
      } else {
        this.findById(this.degreeId);
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    async findById(degreeId) {
      this.isLoading = true;
      this.degree = await degreeService.findById(degreeId);
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;

        this.degree = await degreeService.save(this.degree);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
</style>
